import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import { useState } from "react";
import {
    HistoryFinancialAccountDetailsRow,
    historyFinancialAccountDetailsViewConfig,
} from "./financialAccounts/views/historyFinancialAccountDetailsViewConfig";
import styles from "./HistoryDetails.module.scss";
import { defaultHistoryFinancialAccountDetailsView } from "./financialAccounts/views/defaultHistoryFinancialAccountDetailsView";

interface HistoryFinancialAccountDetailsProps {
    data: HistoryFinancialAccountDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryFinancialAccountDetails: React.FC<
    HistoryFinancialAccountDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(
        defaultHistoryFinancialAccountDetailsView,
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={historyFinancialAccountDetailsViewConfig}
            onViewChange={setView}
            emptyView={() => (
                <EmptyState header="No account changes available" />
            )}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};
